import script from "./bonusomat-board-task.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-board-task.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__